module.exports = __webpack_public_path__ + "static/media/IAB_promo_background_small.837798c3.png";